export default __webpack_public_path__ + "cockroach-topview-red.png?7c9334369d07b1e06eeac6b912a8c4e5";